import React from "react";
import { useSymbolPrices } from "../../../context/WebSocketContext";

const AskValue = React.memo(({ symbolId, digits }) => {
  const { [symbolId]: symbol } = useSymbolPrices();

  return <span className={`${symbol?.askColor == 'down' && 'red'} ${symbol?.askColor == 'up' && 'green'} `}>{symbol ? symbol?.ask?.toFixed(digits) : '0.00'}</span>;
});

export default AskValue;